/**
 * Authentication & Password Reset Flow Step Constants
 */
export const FORGOT_PASSWORD_STEPS = {
  REQUEST_CODE: 'request_code', // Step 1: Input email or RIF
  VERIFY_CODE: 'verify_code',   // Step 2: Input 6-digit OTP code
  NEW_PASSWORD: 'new_password', // Step 3: Input new password and confirmation
};
